module.exports = __webpack_public_path__ + "img/09.c7b012a9.png";